export default "__VITE_ASSET__BCYNcHDm__"